import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './SkipToContent.css';

/**
 * Skip link — invisible par défaut, apparaît au focus (Tab)
 * Permet aux utilisateurs clavier/screen reader de sauter la navigation
 */
const SkipToContent = () => {
  const { t } = useLanguage();
  return (
    <a href="#main-content" className="skip-to-content">
      {t('a11y.skipToContent')}
    </a>
  );
};

export default SkipToContent;
